import { ACCOUNT_SETTINGS_REDIRECT_PATHS } from 'ui/Account/Settings/paths';
import { AUTH_REDIRECT_PATHS } from 'ui/Auth/SignIn/paths';
import { REDIRECT_PATHS as CARE_REDIRECT_PATHS } from 'ui/Care/redirect-paths';
import { REDIRECT_PATHS as COVID_REDIRECT_PATHS } from 'ui/Covid/redirect-paths';
import { REDIRECT_PATHS as ESSENTIAL_CARE_REDIRECT_PATHS } from 'ui/EssentialCare/redirectPaths';
import { LEGACY_ANGULAR_GENETICS_ACTIVATION_REDIRECT_PATHS } from 'ui/Genetics/Activation/paths';
import { PROVIDER_PLATFORM_REDIRECT_PATHS } from 'ui/ProviderPlatform/Providers/paths';
import { ORDER_REDIRECT_PATHS } from 'ui/Purchase/Order/paths';

import { RedirectPathProps } from './types';

export const REDIRECT_PATHS: Array<RedirectPathProps> = [
  ...ACCOUNT_SETTINGS_REDIRECT_PATHS,
  ...CARE_REDIRECT_PATHS,
  ...COVID_REDIRECT_PATHS,
  ...ESSENTIAL_CARE_REDIRECT_PATHS,
  ...AUTH_REDIRECT_PATHS,
  ...PROVIDER_PLATFORM_REDIRECT_PATHS,
  ...ORDER_REDIRECT_PATHS,
  ...LEGACY_ANGULAR_GENETICS_ACTIVATION_REDIRECT_PATHS,
];
